import { render, staticRenderFns } from "./TipoDocumentoList.vue?vue&type=template&id=ff3c5ba0"
import script from "./TipoDocumentoList.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports